import React from 'react'
import PropTypes from 'prop-types'
import styles from './RadioQuizAnswer.css'
import Radio from '@healthwise-ui/core/Radio'
import AnswerCorrectIndicator from '../AnswerCorrectIndicator'
import AnswerIncorrectIndicator from '../AnswerIncorrectIndicator'
import ComponentBuilder from '../../archetypes/ComponentBuilder'
import { getKey } from '@healthwise-ui/core/KeyGen'

class RadioQuizAnswer extends React.Component {
  render () {
    let {
      id,
      name,
      value,
      hiddenLabel,
      label,
      isCorrect,
      hasCorrectAnswer,
      correctAnswerText,
      incorrectAnswerText,
      showEvaluation,
      isSelected,
      onAnswer,
      readonly,
      forPrint,
      ...otherAttributes } = this.props

    if (hiddenLabel) {
      hiddenLabel = <span className={styles.common_hidden_text}>{ hiddenLabel }</span>
    }

    let evaluationIndicator = null
    let mistakenClassName = null
    let answerElement = label
    id = id || getKey()

    if (/^<div(.+)div>$/.test(label)) {
      const componentBuilder = new ComponentBuilder({
        componentMap: [
          {
            when: (node) => { return node && (node.tagName || '').toLowerCase() === 'div' },
            use: 'span',
            withProps: { className: styles.radio_quiz_answer_wrapper }
          }
        ]
      })
      answerElement = componentBuilder.build(label)
    } else {
      answerElement = (<span className={styles.radio_quiz_answer_wrapper} dangerouslySetInnerHTML={{ __html: label }}/>)
    }

    if (isCorrect && showEvaluation) {
      evaluationIndicator = (<span className={styles.radio_quiz_answer_evaluation}><AnswerCorrectIndicator>{ correctAnswerText }</AnswerCorrectIndicator></span>)
      mistakenClassName = styles.radio_quiz_answer_unmistaken
    } else if (hasCorrectAnswer && showEvaluation) {
      evaluationIndicator = (<span className={styles.radio_quiz_answer_evaluation}><AnswerIncorrectIndicator>{ incorrectAnswerText }</AnswerIncorrectIndicator></span>)
      mistakenClassName = styles.radio_quiz_answer_mistaken
    }

    return (
      <div>
        <label htmlFor={id} className={'hw-radio-quiz-answer-label ' + styles.radio_quiz_answer_label + (showEvaluation ? ` ${styles.radio_quiz_answer_active}` : '')} >
          <span className={'hw-radio-quiz-answer-row ' + mistakenClassName + ' ' + styles.radio_quiz_answer_row}>
            {hiddenLabel}
            <span className={styles.radio_quiz_answer_radio_wrapper}>
              <Radio id={id} name={name} value={value} onClick={onAnswer} checked={isSelected} readonly={readonly} forPrint={forPrint} {...otherAttributes} />
            </span>
            {answerElement}
            {evaluationIndicator}
          </span>
        </label>
      </div>
    )
  }
}

RadioQuizAnswer.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  hiddenLabel: PropTypes.string,
  label: PropTypes.string.isRequired,
  correctAnswerText: PropTypes.string,
  incorrectAnswerText: PropTypes.string,
  isCorrect: PropTypes.bool,
  showEvaluation: PropTypes.bool,
  isSelected: PropTypes.bool,
  onAnswer: PropTypes.func,
  hasCorrectAnswer: PropTypes.bool,
  readonly: PropTypes.bool,
  forPrint: PropTypes.bool
}

RadioQuizAnswer.defaultProps = {
  isCorrect: false,
  showEvaluation: false,
  isSelected: false,
  hasCorrectAnswer: false
}

export default RadioQuizAnswer



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/RadioQuizAnswer/index.js